import { createAsyncThunk } from '@reduxjs/toolkit';
import companyRoleApi from '~/apis/company-role';
import { GET_ROLES, GET_ROLE, CREATE_ROLE, UPDATE_ROLE, GET_ROLE_SELECT } from '~/utils/constants/actionType';
import {
  IEditCompanyRole,
  IParamsGetCompanyRoles,
  IResponseGetCompanyRoleDetail,
  IResponseGetCompanyRoles,
} from '~/utils/interface/company-role';

export const handleGetCompanyRoles = createAsyncThunk<IResponseGetCompanyRoles, IParamsGetCompanyRoles>(
  GET_ROLES,
  async (params: IParamsGetCompanyRoles, { rejectWithValue }) => {
    try {
      const res = await companyRoleApi.getCompanyRoles(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateCompanyRole = createAsyncThunk<IResponseGetCompanyRoleDetail, IEditCompanyRole>(
  CREATE_ROLE,
  async (data: IEditCompanyRole, { rejectWithValue }) => {
    try {
      const res = await companyRoleApi.createCompanyRole(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCompanyRole = createAsyncThunk<IResponseGetCompanyRoleDetail, string>(
  GET_ROLE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await companyRoleApi.getCompanyRole(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateCompanyRole = createAsyncThunk<null, { id: number | string; params: IEditCompanyRole }>(
  UPDATE_ROLE,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await companyRoleApi.updateCompanyRole(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCompanyRoleSelect = createAsyncThunk<IResponseGetCompanyRoles>(
  GET_ROLE_SELECT,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await companyRoleApi.getSelect();

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
